import type { ApiSchema } from "../../apiSchema";
import { readArray, readBoolean, readObject, readString } from "../../http/jsonDecoding";
import { keptMembers } from "./keptContentMembers";
import { readStrings } from "./selectorDecoders";
import { decodeToolParameter } from "./toolParameterDecoders";

/** Stored declarations keep their wire shape; the listing API's type view renames members. */
function decodeTypeRef(value: unknown): ApiSchema<"TypeRef"> {
  const reference = readObject(value, "type reference");
  // Stored declarations omit false `many` and empty `holds`; preserve those omissions.
  return {
    type: readString(reference, "type"),
    ...(reference["many"] === undefined ? {} : { many: readBoolean(reference, "many") }),
    ...(reference["holds"] === undefined ? {} : { holds: readStrings(reference["holds"], "held classes") }),
    ...keptMembers(reference, { segment_type: (segmentType) => readString({ segment_type: segmentType }, "segment_type") }),
  };
}

export function decodeInputDeclaration(value: unknown): ApiSchema<"InputDeclaration"> {
  const declaration = readObject(value, "input declaration");
  return {
    name: readString(declaration, "name"),
    label: readString(declaration, "label"),
    description: readString(declaration, "description"),
    accepts: readArray(declaration["accepts"], "accepted types", decodeTypeRef),
    required: readBoolean(declaration, "required"),
    ...keptMembers(declaration, { default: (defaultValue) => defaultValue, parameter: decodeToolParameter }),
  };
}

export function decodeOutputDeclaration(value: unknown): ApiSchema<"OutputDeclaration"> {
  const declaration = readObject(value, "output declaration");
  return { name: readString(declaration, "name"), produces: readArray(declaration["produces"], "produced types", decodeTypeRef) };
}
